import React from 'react';
import { ShopifyProduct } from '../../types/shopify';
import ProductCard from '../ProductCard/ProductCard';
import './ProductGrid.scss';

interface ProductGridProps {
  products: ShopifyProduct[];
  loading?: boolean;
  title?: string;
  showFilters?: boolean;
}

const ProductGrid: React.FC<ProductGridProps> = ({ 
  products, 
  loading = false, 
  title,
  showFilters = false 
}) => {
  if (loading) {
    return (
      <div className="product-grid">
        <div className="product-grid__loading">
          <div className="product-grid__skeleton">
            {Array.from({ length: 6 }).map((_, index) => (
              <div key={index} className="product-grid__skeleton-item">
                <div className="product-grid__skeleton-image"></div>
                <div className="product-grid__skeleton-title"></div>
                <div className="product-grid__skeleton-price"></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }

  if (products.length === 0) {
    return (
      <div className="product-grid">
        <div className="product-grid__empty">
          <p>No products found.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="product-grid">
      {title && (
        <div className="product-grid__header">
          <h2 className="product-grid__title">{title}</h2>
          {showFilters && (
            <div className="product-grid__filters">
              <button className="product-grid__filter-toggle">
                Filters
              </button>
              <div className="product-grid__sort">
                <select className="product-grid__sort-select">
                  <option value="latest">Latest Arrivals</option>
                  <option value="price-low-high">Price: Low to High</option>
                  <option value="price-high-low">Price: High to Low</option>
                  <option value="alphabetical">Alphabetical</option>
                </select>
              </div>
            </div>
          )}
        </div>
      )}

      <div className="product-grid__container">
        {products.map((product) => (
          <ProductCard key={product.id} product={product} />
        ))}
      </div>
    </div>
  );
};

export default ProductGrid;